module.exports = __webpack_public_path__ + "static/img/system_1.6ad4691e.svg";